import { compact } from 'utilities/array'

export const empty = {
    value: '',
    text: ''
}

export const unpackValue = value => (!!value && typeof value === 'object') ?
    value.id :
    value

export const getDisplayValue = (value, options) => compact(options)
    .find(option => `${option.value}` === `${value}`)
    ?.text ?? ''